import { Draggable } from "@hello-pangea/dnd";
import React, { useState } from "react";
import { Image } from "react-bootstrap";
import styles from "../styles/imageDraggableComponent.module.css";
import btnStyles from "../styles/globalButtonStylng.module.css";

interface IImage {
  id: string;
  imageUrl: string;
  createdAt: string;
}

interface ImageDraggableProps {
  img: IImage;
  index: number;
  draggableType: "library" | "carousel";
  handleDelete: Function;
}

export const ImageDraggableComponent: React.FC<ImageDraggableProps> = ({ img, index, draggableType, handleDelete }) => {
  const [isHovered, setIsHovered] = useState(false);
  const isDragDisabled = draggableType === "carousel";
  return (
    <Draggable key={img.id} draggableId={img.createdAt} index={index} isDragDisabled={isDragDisabled}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={draggableType === "carousel" ? "mw-100 mh-100 rounded-0" : styles.imageSlot}
          style={{ position: "relative" }} // Ensure the position is relative for absolute positioning of children
          onMouseEnter={() => setIsHovered(true && !isDragDisabled)}
          onMouseLeave={() => setIsHovered(false && !isDragDisabled)}
        >
          <Image src={img.imageUrl} alt={`image id:${img.id}`} thumbnail />
          {draggableType === "library" && isHovered && (
            <button
              onClick={() => handleDelete(img.id)}
              className={btnStyles.Cancel}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                padding: "5px 10px",
                cursor: "pointer",
                color: "white",
                
                marginTop: 5,
                marginRight: 5,
                
              }}
            >
              Delete
            </button>
          )}
        </div>
      )}
    </Draggable>
  );
};

//export default ImageDraggableComponent;
